.container {
  display: grid;
  gap: 32px;
  padding-block: 16px;
  margin-inline: auto;
}

.overview {
  display: grid;
  gap: 32px;
}

.description {
  display: grid;
  gap: 16px;
}

.heading {
  font-size: var(--font-size-xl);
  font-weight: 700;
  text-align: center;
}

.detail {
  font-size: var(--font-size-sm);
  text-align: left;

  > span {
    display: block;
  }
}

.sections {
  display: grid;
  gap: 32px;
}

.buttonContainer {
  display: flex;
  flex-direction: column-reverse;
  gap: 16px;
  justify-content: center;
}

@media screen and (width >= 600px) {
  .container {
    padding-block: 24px;
  }
}

@media screen and (width >= 769px) {
  .container {
    gap: 48px;
    padding-block: 62px;
  }

  .overview {
    gap: 48px;
  }

  .description {
    gap: 48px;
  }

  .detail {
    text-align: center;
  }

  .buttonContainer {
    flex-direction: row;

    > button {
      width: 180px;
      padding: 0;
      font-size: var(--font-size-md);
    }
  }
}

@media screen and (width >= 900px) {
  .container {
    width: 840px;
  }
}
